import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ApplicationScreen, ScreenContextMenuItem } from 'src/app/application-navigator/application-screen';
import { SampleBooksService, BinderSpecification } from 'src/app/acumatica/EntityServices/SampleBooks.service';
import { Customer, CustomerLocation } from 'src/app/acumatica/EntityServices/Customer.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialog } from 'src/app/common/confirmation-dialog/confirmation-dialog.component';
import { CustomerIDSelectorComponent } from 'src/app/common/customer-id-selector/customer-id-selector.component';

@Component({
  selector: 'app-binder-audit',
  templateUrl: './binder-selection.component.html',
  styleUrls: ['./binder-selection.component.css']
})
export class BinderSelectionComponent extends ApplicationScreen implements OnInit, AfterViewInit {
  pageTitle: string = "Binder Audit - Selection";
  customerID: string = '';
  @ViewChild('customerSelector') customerSelector!: CustomerIDSelectorComponent;

  get shipToLocation(): CustomerLocation | undefined { return this.binders.order.shipToLocation; }
  set shipToLocation(value: CustomerLocation | undefined) { this.binders.order.shipToLocation = value; }
  get customerLocations() { return this.binders.order.customer?.Locations; }

  constructor(
    private router: Router,
    public binders: SampleBooksService,
    private mayerfabrics: MayerFabricsService,
    private dialog: MatDialog
  ) {
    super();

    if (this.mayerfabrics.RepCustomerID == null || this.mayerfabrics.RepWarehouseID == null) {
      this.router.navigate(['/']);
    }
  }

  screenMenuItems: ScreenContextMenuItem[] = [
    {
      icon: 'inventory_2',
      label: 'Loose Card Mode',
      handler: () => this.binders.LooseCards = true,
      condition: () => false && this.binders.LooseCards == false
    },
    {
      icon: 'auto_stories',
      label: 'By Binder Mode',
      handler: () => this.binders.LooseCards = false,
      condition: () => false && this.binders.LooseCards == true
    },
    {
      icon: 'file_download',
      label: 'Refresh Binder Contents',
      handler: () => this.binders.RefreshBinders()
    },
    {
      icon: 'restart_alt',
      label: 'Reset Audit',
      handler: () => {
        this.dialog.open(ConfirmationDialog, {
          data: {
            message: 'Reset all current binder/card audit details?',
            confirmText: 'Yes, Reset',
            cancelText: 'No, Cancel'
          }
        }).afterClosed().subscribe(response => {
          if (!response) return;
          this.customerSelector.customerID = undefined;
          this.binders.resetAuditOrder();
          this.customerSelector.focus();
        })
      }
    }
  ];

  ngOnInit(): void {
    this.customerID = this.binders.customerID || '';
  }

  ngAfterViewInit(): void {
    if (!this.customerID) this.customerSelector.focus();
  }

  gotoBinderAudit(inventoryID?: string) {
    if (!inventoryID) return;
    this.router.navigate(['/binder-audit/', inventoryID]);
  }

  binderAuditProgress(binder: BinderSpecification): string {
    let progress = this.binders.auditProgress(binder);
    return progress.total == 0 ? '' : progress.audited + ' of ' + progress.total;
  }

  reviewAndPlace() {
    this.router.navigate(['/binder-audit/review']);
  }

  customerSelectorChange(customer: Customer | null) {
    this.binders.customer = customer;
  }

  doBlur(event: Event) { (<HTMLElement>event.target!).blur(); }
}
